import { useCallback } from 'react';
import PropTypes from 'prop-types';
import NiceModal from '@ebay/nice-modal-react';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import { getContextUser, hasContextPermissionById } from 'features/views/userContext/selectors';
import { getCodelistByName, getCodelistPropById } from 'utils';

import SettingsSwitch from './SettingsSwitch';

export const SettingsSwitchWithModalLink = ({
	notificationSetId,
	description,
	doNotUseCodelistPermissionForModalLink = false,
}) => {
	const contextUser = useSelector(getContextUser);

	const notificationsSetCodelist = useSelector(getCodelistByName(codelists.notificationsSet));
	const permissionByNotificationSetId = getCodelistPropById(
		`${notificationSetId}`,
		notificationsSetCodelist || [],
		'permissionId',
	);

	const formattedPermissionId = [{ id: permissionByNotificationSetId }];
	const userPermission = useSelector((state) => hasPermissionByIds(state)(formattedPermissionId));
	const contextUserPermission = useSelector((state) => hasContextPermissionById(state, formattedPermissionId));
	const hasCodelistPermissionForModalLink = contextUser ? contextUserPermission : userPermission;

	const handleOpenModal = useCallback(() => {
		NiceModal.show(MODALS.custom_settings, { notificationSetId });
	}, [notificationSetId]);

	const modalLink = (
		<Link sx={{ cursor: 'pointer' }} underline="none" onClick={handleOpenModal}>
			{getLabelMessage('settings:customSettings')}
		</Link>
	);

	return (
		<Stack
			direction="row"
			spacing={3}
			sx={{
				alignItems: 'center',
			}}
		>
			<SettingsSwitch description={description} notificationSetId={notificationSetId} />
			{doNotUseCodelistPermissionForModalLink ? modalLink : hasCodelistPermissionForModalLink && modalLink}
		</Stack>
	);
};

SettingsSwitchWithModalLink.propTypes = {
	description: PropTypes.string,
	doNotUseCodelistPermissionForModalLink: PropTypes.bool,
	notificationSetId: PropTypes.number,
};

export default SettingsSwitchWithModalLink;
